import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';
import { LoaderService } from '../_services/loader.service';
import { inject } from '@angular/core';

let serviceCount = 0;

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  loaderService.show();
  serviceCount++;
  return next(req).pipe(
    finalize(() => {
      serviceCount--;
      if (serviceCount === 0) {
        loaderService.hide();
      }
    })
  );
};
